/**
 * Utility functions for ModelDownloadModal component
 */

/**
 * Classify a file by its role: 'input' (i_scaler), 'output' (o_scaler), or 'model' (.h5/.pkl)
 */
export type FileCategory = 'input' | 'output' | 'model';

export const getFileCategory = (filename: string): FileCategory => {
  if (filename.includes('i_scaler')) return 'input';
  if (filename.includes('o_scaler')) return 'output';
  return 'model';
};

/**
 * Get badge color classes based on file category
 */
export const getModelTypeColor = (_type: string, filename: string): string => {
  const category = getFileCategory(filename);
  switch (category) {
    case 'input':
      return 'bg-emerald-50 text-emerald-700';
    case 'output':
      return 'bg-amber-50 text-amber-700';
    case 'model':
      return 'bg-accent text-primary';
    default:
      return 'bg-slate-100 text-slate-600';
  }
};

/**
 * Get left accent border color based on file category
 */
export const getModelTypeAccent = (_type: string, filename: string): string => {
  const category = getFileCategory(filename);
  switch (category) {
    case 'input':
      return 'bg-emerald-500';
    case 'output':
      return 'bg-amber-500';
    case 'model':
      return 'bg-primary';
    default:
      return 'bg-slate-400';
  }
};

/**
 * Format date string based on language
 */
export const formatDate = (dateString: string, language: string): string => {
  return new Date(dateString).toLocaleString(language === 'de' ? 'de-DE' : 'en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
